import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { Quadrant } from "@msc/shared";

const QUADRANT_COLORS: Record<Quadrant, string> = {
  star: "yellow",
  cash_cow: "green",
  question_mark: "blue",
  dog: "gray",
};

interface QuadrantBadgeProps {
  quadrant: Quadrant | null;
}

export function QuadrantBadge({ quadrant }: QuadrantBadgeProps) {
  const { t } = useTranslation();
  if (!quadrant) {
    return (
      <Badge color="gray" variant="outline">
        {t("common.dashed")}
      </Badge>
    );
  }
  return (
    <Badge color={QUADRANT_COLORS[quadrant]} variant="filled">
      {t(`quadrant.${quadrant}`)}
    </Badge>
  );
}
